import React from 'react';
import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';
import ToggleSwitch from '../elements/toggleSwitch/ToggleSwitch';
import { PRODUCT_FLAG_TOOLTIPS } from '../../constants/product-constants';
import { formatPriceWithCurrency } from '../../utils/formatPrice';

const ProductQuickSettingsModal = ({
  visible,
  product,
  onClose,
  onToggleHide,
  onToggleConfigurationProduct,
  onToggleMix4IndividuallySellable,
  onToggleQuantityDiscount,
  onToggleEligibleToBuyWithPoints,
  onToggleExternalProduct,
  onToggleSubscriptionOnly,
  onToggleFrozenProduct,
  onToggleSkipReferredDiscount,
}) => {
  if (!product) return null;

  const categoryLabel =
    product.categories && product.categories.length > 0
      ? product.categories.map((c) => c?.name).join(', ')
      : '-';

  return (
    <Modal
      className="create_user_modal"
      title="Brza podešavanja"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" className="btn-tertiary" onClick={onClose}>
          Zatvori
        </Button>,
      ]}
    >
      <p style={{ marginBottom: 4 }}>
        Proizvod: <strong>{product.name}</strong>
      </p>
      <p style={{ marginBottom: 20, color: '#8a8a8a' }}>
        Kategorija: {categoryLabel} · Cena: {formatPriceWithCurrency(product.regular_price || 0)}
      </p>

      <div
        className="create_user_modal_form"
        style={{ display: 'flex', flexDirection: 'column', gap: '20px', margin: 0 }}
      >
        <ToggleSwitch
          checked={!product?.isProductHidden}
          onChange={(e) => onToggleHide(product, e.target.checked)}
          label="Pretplatnički proizvod"
          tooltip={PRODUCT_FLAG_TOOLTIPS.isProductHidden}
        />
        <ToggleSwitch
          checked={product?.isConfigurationProduct || false}
          onChange={(e) => onToggleConfigurationProduct(product, e.target.checked)}
          label="Konfiguracioni proizvod"
          tooltip={PRODUCT_FLAG_TOOLTIPS.isConfigurationProduct}
        />
        <ToggleSwitch
          checked={product?.isMix4IndividuallySellable || false}
          onChange={(e) => onToggleMix4IndividuallySellable(product, e.target.checked)}
          label="Mix4 — pojedinačna prodaja"
          tooltip={PRODUCT_FLAG_TOOLTIPS.isMix4IndividuallySellable}
        />
        <ToggleSwitch
          checked={product?.hasQuantityDiscount || false}
          onChange={(e) => onToggleQuantityDiscount(product, e.target.checked)}
          label="Količinski popust"
          tooltip={PRODUCT_FLAG_TOOLTIPS.hasQuantityDiscount}
        />
        <ToggleSwitch
          checked={product?.isEligibleToBuyWithPoints !== false}
          onChange={(e) => onToggleEligibleToBuyWithPoints(product, e.target.checked)}
          label="Kupovina poenima"
          tooltip={PRODUCT_FLAG_TOOLTIPS.isEligibleToBuyWithPoints}
        />
        <ToggleSwitch
          checked={product?.isExternalProduct || false}
          onChange={(e) => onToggleExternalProduct(product, e.target.checked)}
          label="Eksterni proizvod"
          tooltip={PRODUCT_FLAG_TOOLTIPS.isExternalProduct}
        />
        <ToggleSwitch
          checked={product?.isSubscriptionOnlyProduct || false}
          onChange={(e) => onToggleSubscriptionOnly(product, e.target.checked)}
          label="Pretplatnički paket (3/6/12)"
          tooltip={PRODUCT_FLAG_TOOLTIPS.isSubscriptionOnlyProduct}
        />
        <ToggleSwitch
          checked={product?.isFrozenProduct || false}
          onChange={(e) => onToggleFrozenProduct(product, e.target.checked)}
          label="Zamrznut proizvod"
          tooltip={PRODUCT_FLAG_TOOLTIPS.isFrozenProduct}
        />
        <ToggleSwitch
          checked={product?.skipReferredDiscount || false}
          onChange={(e) => onToggleSkipReferredDiscount(product, e.target.checked)}
          label="Isključi 5% popust"
          tooltip={PRODUCT_FLAG_TOOLTIPS.skipReferredDiscount}
        />
      </div>
    </Modal>
  );
};

ProductQuickSettingsModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  product: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onToggleHide: PropTypes.func.isRequired,
  onToggleConfigurationProduct: PropTypes.func.isRequired,
  onToggleMix4IndividuallySellable: PropTypes.func.isRequired,
  onToggleQuantityDiscount: PropTypes.func.isRequired,
  onToggleEligibleToBuyWithPoints: PropTypes.func.isRequired,
  onToggleExternalProduct: PropTypes.func.isRequired,
  onToggleSubscriptionOnly: PropTypes.func.isRequired,
  onToggleFrozenProduct: PropTypes.func.isRequired,
  onToggleSkipReferredDiscount: PropTypes.func.isRequired,
};

export default ProductQuickSettingsModal;
